export const DEFAULT_SEARCH_LIMITApi = 20;
export const DEFAULT_CONTEXT_WINDOWApi = 5;
export const MEMBERSHIP_CHATS_PER_PROJECT_LIMITApi = 3;
export const GROUPCHAT_INVITE_LIMITApi = 15;
export const GROUPCHAT_MEMBER_LIMITApi = 25;
export const ATTACHMENTS_FORWARD_MAX_LIMITApi = 10;
export var PrivacyLevelApi;
(function (PrivacyLevelApi) {
    PrivacyLevelApi["OWNER"] = "owner";
    PrivacyLevelApi["MEMBERS"] = "members";
    PrivacyLevelApi["ALL"] = "all";
    PrivacyLevelApi["MINE"] = "mine";
    PrivacyLevelApi["NONE"] = "none";
    PrivacyLevelApi["OWNER_AUTOCHAT"] = "owner_autochat";
})(PrivacyLevelApi || (PrivacyLevelApi = {}));
export var SourceTypeApi;
(function (SourceTypeApi) {
    SourceTypeApi["DEFAULT_MSG"] = "default_msg";
    SourceTypeApi["BID"] = "bid";
    SourceTypeApi["ADMIN"] = "admin";
    SourceTypeApi["SMTP"] = "smtp";
    SourceTypeApi["IOS"] = "ios";
    SourceTypeApi["HIREME"] = "hireme";
    SourceTypeApi["ANDROID"] = "android";
    SourceTypeApi["MOBILE_WEB"] = "mobile_web";
    SourceTypeApi["CHAT_BOX"] = "chat_box";
    SourceTypeApi["INBOX"] = "inbox";
    SourceTypeApi["DESKTOP_APPLICATION"] = "desktop_application";
    SourceTypeApi["AUTOCHAT"] = "autochat";
    SourceTypeApi["USER_SIDE_ACTION"] = "user_side_action";
    SourceTypeApi["MEMBERSHIP"] = "membership";
    SourceTypeApi["IMPORTED"] = "imported";
    SourceTypeApi["BOT"] = "bot";
    SourceTypeApi["BLAST"] = "blast";
    SourceTypeApi["ADMIN_BLAST"] = "admin_blast";
    SourceTypeApi["MESSAGE_CAMPAIGN_BLAST"] = "message_campaign_blast";
})(SourceTypeApi || (SourceTypeApi = {}));
export var FolderApi;
(function (FolderApi) {
    FolderApi["INBOX"] = "inbox";
    FolderApi["ARCHIVED"] = "archived";
    FolderApi["SENT"] = "sent";
    FolderApi["FREELANCER"] = "freelancer";
    FolderApi["NONE"] = "none";
    FolderApi["REQUESTS"] = "requests";
})(FolderApi || (FolderApi = {}));
export var ThreadTypeApi;
(function (ThreadTypeApi) {
    ThreadTypeApi["PRIVATE_CHAT"] = "private_chat";
    ThreadTypeApi["GROUP"] = "group";
    ThreadTypeApi["PCB"] = "pcb";
    ThreadTypeApi["PRIMARY"] = "primary";
    ThreadTypeApi["SUPPORT_CHAT"] = "support_chat";
    ThreadTypeApi["ADMIN_PREFERRED_CHAT"] = "admin_preferred_chat";
    ThreadTypeApi["TEAM"] = "team";
    ThreadTypeApi["TEAM_OFFICIAL"] = "team_official";
    ThreadTypeApi["COMMENT_FEED"] = "comment_feed";
    ThreadTypeApi["PROMOTIONAL_CHAT"] = "promotional_chat";
    ThreadTypeApi["AI_CHAT"] = "ai_chat";
})(ThreadTypeApi || (ThreadTypeApi = {}));
export var ContextTypeApi;
(function (ContextTypeApi) {
    ContextTypeApi["NONE"] = "none";
    ContextTypeApi["PROJECT"] = "project";
    ContextTypeApi["CONTEST"] = "contest";
    ContextTypeApi["SUPPORT_CHAT"] = "support_chat";
    ContextTypeApi["SUPPORT_SESSION"] = "support_session";
    ContextTypeApi["PREHIRE"] = "prehire";
    ContextTypeApi["TEAM"] = "team";
    ContextTypeApi["POST"] = "post";
    ContextTypeApi["CHAT_REQUEST"] = "chat_request";
    ContextTypeApi["TASK"] = "task";
})(ContextTypeApi || (ContextTypeApi = {}));
export var CommentsDeleteContextTypeApi;
(function (CommentsDeleteContextTypeApi) {
    CommentsDeleteContextTypeApi["GROUP"] = "group";
    CommentsDeleteContextTypeApi["PROJECT"] = "project";
})(CommentsDeleteContextTypeApi || (CommentsDeleteContextTypeApi = {}));
export const ThreadTypeContextsMapApi = {
    [ThreadTypeApi.PRIVATE_CHAT]: [
        ContextTypeApi.PROJECT,
        ContextTypeApi.CONTEST,
        ContextTypeApi.SUPPORT_SESSION,
        ContextTypeApi.PREHIRE,
        ContextTypeApi.TEAM,
        ContextTypeApi.CHAT_REQUEST,
    ],
    [ThreadTypeApi.GROUP]: [
        ContextTypeApi.PROJECT,
        ContextTypeApi.CONTEST,
        ContextTypeApi.TEAM,
        ContextTypeApi.SUPPORT_SESSION,
        ContextTypeApi.SUPPORT_CHAT,
    ],
    [ThreadTypeApi.PCB]: [],
    [ThreadTypeApi.PRIMARY]: [ContextTypeApi.NONE],
    [ThreadTypeApi.SUPPORT_CHAT]: [ContextTypeApi.SUPPORT_SESSION],
    [ThreadTypeApi.ADMIN_PREFERRED_CHAT]: [
        ContextTypeApi.PROJECT,
        ContextTypeApi.NONE,
        ContextTypeApi.SUPPORT_CHAT,
        ContextTypeApi.SUPPORT_SESSION,
    ],
    [ThreadTypeApi.TEAM]: [ContextTypeApi.PROJECT, ContextTypeApi.CONTEST],
    [ThreadTypeApi.TEAM_OFFICIAL]: [ContextTypeApi.TEAM],
    [ThreadTypeApi.COMMENT_FEED]: [
        ContextTypeApi.POST,
        ContextTypeApi.PROJECT,
        ContextTypeApi.TASK,
    ],
    [ThreadTypeApi.PROMOTIONAL_CHAT]: [ContextTypeApi.NONE],
    [ThreadTypeApi.AI_CHAT]: [ContextTypeApi.NONE],
};
export const ThreadTypeContextErrorTextApi = {
    [ThreadTypeApi.PRIVATE_CHAT]: 'Invalid context provided for thread type private chat.',
    [ThreadTypeApi.GROUP]: 'Invalid context provided for thread type group.',
    [ThreadTypeApi.PCB]: 'This thread type is deprecated, please try another for this context.',
    [ThreadTypeApi.PRIMARY]: 'Default threads must not have a context.',
    [ThreadTypeApi.SUPPORT_CHAT]: 'Invalid context provided for thread type support chat.',
    [ThreadTypeApi.ADMIN_PREFERRED_CHAT]: 'Invalid context provided for thread type admin preferred chat.',
    [ThreadTypeApi.TEAM]: 'Threads with a team context must have a team_official, group, or private_chat type.',
    [ThreadTypeApi.TEAM_OFFICIAL]: 'Official team threads must have a valid team context.',
    [ThreadTypeApi.COMMENT_FEED]: 'Invalid context for comment feeds.',
    [ThreadTypeApi.AI_CHAT]: 'Invalid context for ai chat.',
};
export var ThreadEventTypeApi;
(function (ThreadEventTypeApi) {
    ThreadEventTypeApi["JOIN_GROUP_CHAT"] = "join_group_chat";
    ThreadEventTypeApi["LEAVE_GROUP_CHAT"] = "leave_group_chat";
})(ThreadEventTypeApi || (ThreadEventTypeApi = {}));
export var RemovalReasonApi;
(function (RemovalReasonApi) {
    RemovalReasonApi["CONTACTS"] = "contacts";
    RemovalReasonApi["ADVERTISING"] = "advertising";
    RemovalReasonApi["HARASSMENT"] = "harassment";
    RemovalReasonApi["FAKE"] = "fake";
    RemovalReasonApi["NONFEATURED"] = "nonfeatured";
    RemovalReasonApi["OTHER"] = "other";
    RemovalReasonApi["OFFSITING"] = "offsiting";
    RemovalReasonApi["MILESTONE_RELEASE_ABUSE"] = "milestone_release_abuse";
    RemovalReasonApi["PRIVACY_DELETE"] = "privacy_delete";
    RemovalReasonApi["OWNER_DELETE"] = "owner_delete";
    RemovalReasonApi["SPAM"] = "spam";
    RemovalReasonApi["DISCLOSING_PERSONAL_DETAILS"] = "disclosing_personal_details";
    RemovalReasonApi["SCAM"] = "scam";
    RemovalReasonApi["OFFENSIVE"] = "offensive";
    RemovalReasonApi["IRRELEVANT"] = "irrelevant";
    RemovalReasonApi["DOWNVOTED"] = "downvoted";
})(RemovalReasonApi || (RemovalReasonApi = {}));
export var RemoveFromTimeApi;
(function (RemoveFromTimeApi) {
    RemoveFromTimeApi["ALL"] = "all";
    RemoveFromTimeApi["LAST_DAY"] = "last_day";
    RemoveFromTimeApi["LAST_WEEK"] = "last_week";
    RemoveFromTimeApi["LAST_MONTH"] = "last_month";
})(RemoveFromTimeApi || (RemoveFromTimeApi = {}));
export var MessageUserSettingTypeApi;
(function (MessageUserSettingTypeApi) {
    MessageUserSettingTypeApi["PIN"] = "pin";
    MessageUserSettingTypeApi["STAR"] = "star";
})(MessageUserSettingTypeApi || (MessageUserSettingTypeApi = {}));
export var MessageWarningTypeApi;
(function (MessageWarningTypeApi) {
    MessageWarningTypeApi["NONE"] = "none";
    MessageWarningTypeApi["ADMIN"] = "admin";
})(MessageWarningTypeApi || (MessageWarningTypeApi = {}));
export const RemovalReasonKeysApi = {
    [RemovalReasonApi.CONTACTS]: 'Contacts',
    [RemovalReasonApi.ADVERTISING]: 'Advertising',
    [RemovalReasonApi.HARASSMENT]: 'Harassment',
    [RemovalReasonApi.FAKE]: 'Fake',
    [RemovalReasonApi.NONFEATURED]: 'Non-featured',
    [RemovalReasonApi.OTHER]: 'Other',
    [RemovalReasonApi.OFFSITING]: 'Offsiting',
    [RemovalReasonApi.MILESTONE_RELEASE_ABUSE]: 'MilestoneHarassment',
    [RemovalReasonApi.PRIVACY_DELETE]: 'PrivacyDelete',
    [RemovalReasonApi.OWNER_DELETE]: 'OwnerDelete',
    [RemovalReasonApi.SPAM]: 'Spam',
    [RemovalReasonApi.DISCLOSING_PERSONAL_DETAILS]: 'DisclosingPersonalDetails',
    [RemovalReasonApi.SCAM]: 'Scam',
    [RemovalReasonApi.OFFENSIVE]: 'Offensive',
    [RemovalReasonApi.IRRELEVANT]: 'Irrelevant',
};
export const RemovalReasonTextApi = {
    [RemovalReasonApi.CONTACTS]: 'The Administrator removed this message for containing contacts details which breaches our Terms of Service',
    [RemovalReasonApi.ADVERTISING]: 'The Administrator removed this message for advertising a third-party website which breaches our Terms of Service',
    [RemovalReasonApi.HARASSMENT]: 'The Administrator removed this message for containing inappropriate or abusive language which breaches our Terms of Service',
    [RemovalReasonApi.FAKE]: 'The Administrator removed this message for breaching our Terms of Service',
    [RemovalReasonApi.NONFEATURED]: 'The Administrator removed this message for breaching our Terms of Service',
    [RemovalReasonApi.OTHER]: 'The Administrator removed this message for breaching our Terms of Service',
    [RemovalReasonApi.OFFSITING]: 'The Administrator removed this message for breaching our Terms of Service',
    [RemovalReasonApi.MILESTONE_RELEASE_ABUSE]: 'The Administrator removed this message for breaching our Terms of Service',
    [RemovalReasonApi.PRIVACY_DELETE]: 'This message has been removed by the administrator.',
    [RemovalReasonApi.OWNER_DELETE]: 'This message has been removed by the owner of the content.',
    [RemovalReasonApi.SPAM]: 'The Administrator removed this message for breaching our Terms of Service',
    [RemovalReasonApi.DISCLOSING_PERSONAL_DETAILS]: 'The Administrator removed this message for breaching our Terms of Service',
    [RemovalReasonApi.SCAM]: 'The Administrator removed this message for breaching our Terms of Service',
    [RemovalReasonApi.OFFENSIVE]: 'The Administrator removed this message for breaching our Terms of Service',
    [RemovalReasonApi.IRRELEVANT]: 'The Administrator removed this message because it is not relevant.',
    [RemovalReasonApi.DOWNVOTED]: 'The Administrator removed this message because it has received too many downvotes.',
};
export var HighlightedFieldApi;
(function (HighlightedFieldApi) {
    HighlightedFieldApi["MESSAGE"] = "message";
    HighlightedFieldApi["USERNAME"] = "username";
})(HighlightedFieldApi || (HighlightedFieldApi = {}));
export var AdminSupportSessionStateApi;
(function (AdminSupportSessionStateApi) {
    AdminSupportSessionStateApi["PENDING"] = "pending";
    AdminSupportSessionStateApi["CANCELED"] = "canceled";
    AdminSupportSessionStateApi["CLOSED"] = "closed";
    AdminSupportSessionStateApi["ACTIVE"] = "active";
    AdminSupportSessionStateApi["REASSIGNED"] = "reassigned";
    AdminSupportSessionStateApi["ARCHIVED"] = "archived";
})(AdminSupportSessionStateApi || (AdminSupportSessionStateApi = {}));
export var AdminSupportSessionTypeApi;
(function (AdminSupportSessionTypeApi) {
    AdminSupportSessionTypeApi["TECHNICAL"] = "technical";
    AdminSupportSessionTypeApi["ASSISTED"] = "assisted";
    AdminSupportSessionTypeApi["GENERAL"] = "general";
    AdminSupportSessionTypeApi["LOCAL"] = "local";
})(AdminSupportSessionTypeApi || (AdminSupportSessionTypeApi = {}));
export var VisibilityStateApi;
(function (VisibilityStateApi) {
    VisibilityStateApi["ALL"] = "all";
    VisibilityStateApi["NONE"] = "none";
    VisibilityStateApi["INCLUDES"] = "includes";
    VisibilityStateApi["EXCLUDES"] = "excludes";
})(VisibilityStateApi || (VisibilityStateApi = {}));
export var ReferenceTypeApi;
(function (ReferenceTypeApi) {
    ReferenceTypeApi["BID"] = "bid";
    ReferenceTypeApi["MILESTONE"] = "milestone";
    ReferenceTypeApi["PREHIRE"] = "prehire";
    ReferenceTypeApi["PROJECT"] = "project";
    ReferenceTypeApi["SUPPORT_SESSION"] = "support_session";
    ReferenceTypeApi["TASK"] = "task";
    ReferenceTypeApi["SELECTED_SELLER"] = "selected_seller";
    ReferenceTypeApi["CONTEST"] = "contest";
    ReferenceTypeApi["QUOTATION"] = "quotation";
    ReferenceTypeApi["MESSAGE_CAMPAIGN"] = "message_campaign";
    ReferenceTypeApi["USER"] = "user";
})(ReferenceTypeApi || (ReferenceTypeApi = {}));
export var ThreadShareContextApi;
(function (ThreadShareContextApi) {
    ThreadShareContextApi["PROJECT"] = "project";
    ThreadShareContextApi["CONTEST"] = "contest";
})(ThreadShareContextApi || (ThreadShareContextApi = {}));
export var RichMessageTypeApi;
(function (RichMessageTypeApi) {
    RichMessageTypeApi["SHARE_PROJECT"] = "share_project";
    RichMessageTypeApi["SHARE_CONTEST"] = "share_contest";
})(RichMessageTypeApi || (RichMessageTypeApi = {}));
export var VideochatSDPTypeApi;
(function (VideochatSDPTypeApi) {
    VideochatSDPTypeApi["OFFER"] = "offer";
    VideochatSDPTypeApi["PRANSWER"] = "pranswer";
    VideochatSDPTypeApi["ANSWER"] = "answer";
})(VideochatSDPTypeApi || (VideochatSDPTypeApi = {}));
export var VideochatCloseReasonApi;
(function (VideochatCloseReasonApi) {
    VideochatCloseReasonApi["UNSPECIFIED"] = "unspecified";
    VideochatCloseReasonApi["UNANSWERED"] = "unanswered";
})(VideochatCloseReasonApi || (VideochatCloseReasonApi = {}));
